import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Breadcrumb, Table, CardHeader } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { Link, useNavigate, useParams } from 'react-router-dom'; // Assuming React Router is used
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { Avatar } from 'primereact/avatar';
import { Badge } from 'primereact/badge';
import { Tooltip } from 'primereact/tooltip';
import { TabView, TabPanel } from 'primereact/tabview';
import { ProgressBar } from 'primereact/progressbar';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { Chart } from 'primereact/chart';
import Client_for_invoice from '../../components/Client_for_invoice';
import Client_projects from '../../components/Client_projects';
import Client_onboarding_details from '../../components/Client_onboarding_details';
import GifLoder from '../../components/GifLoder';

const View_client = () => {
  const { accessToken } = useAuth();
  const { clientId } = useParams(); // Extract clientId from the route params
  const [loading, setLoading] = useState(true);
  // const [buttonTooltip, setButtonTooltip] = useState('+91-1234567890');
  // const [buttonTooltip2, setButtonTooltip2] = useState('asiyajavayant@gmail.com');
  // const [buttonTooltip3, setButtonTooltip3] = useState('Edit Profile');

  const [clientData, setClientData] = useState(null);
  const navigate = useNavigate();
  /*------------Chart-------------*/
 
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

    // Example revenue data for full year (current and previous year)
    const revenueData = {
      2024: {
        "Project A": [
          6500, 5900, 8000, 8100, 5600, 5500, 4000, 4500, 4800, 5200, 6100, 6300,
        ],
      },
      2025: {
        "Project A": [
          6200, 5700, 7800, 7900, 5400, 5300, 3900, 4400, 4600, 5000, 5900, 6000,
        ],
      },
    };

    const currentYear = 2025;
    const previousYear = currentYear - 1;
    const project = "Project A";

    const data = {
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      datasets: [
        {
          label: `Revenue (${currentYear})`,
          backgroundColor: documentStyle.getPropertyValue("--pink-400"),
          borderColor: documentStyle.getPropertyValue("--pink-800"),
          data: revenueData[currentYear]?.[project] || [],
        },
        {
          label: `Revenue (${previousYear})`,
          backgroundColor: documentStyle.getPropertyValue("--cyan-400"),
          borderColor: documentStyle.getPropertyValue("--cyan-800"),
          data: revenueData[previousYear]?.[project] || [],
        },
      ],
    };

    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500,
            },
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
            callback: (value) => `₹${value}`, // Format y-axis as currency
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleView = () => {
    setIsExpanded(!isExpanded);
  };




  const fetchClientData = async () => {
    try {
      // Simulate a delay of 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 1200));

      const response = await axios.get(`${config.apiBASEURL}/ClientRoutes/client/${clientId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setClientData(response.data);
    } catch (err) {
      console.error('Error fetching client data:', err);
    } finally {
      setLoading(false); // Ensure loading is set to false after the delay and fetch
    }
  };

  useEffect(() => {
    fetchClientData();
  }, [clientId, accessToken]);








  if (loading) {
    return <div className="loderDiv">
      <GifLoder />
    </div>;
  }

  return (
    <>
      <Row className="body_content">
        <Row className="mx-0">
          <Col sm={4} className="mb-4 d-flex justify-content-between align-items-center">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
                <i className='pi pi-angle-left'></i> Back
              </Breadcrumb.Item>
              <Breadcrumb.Item active>View Client</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col sm={8} className="p-0 text-end mb-4">

          </Col>
          <Col sm={12} className="p-0">
            <Row className='mx-0'>
              <Col xl={4}>
                <Card className='h-auto'>
                  <Card.Header>
                    <div className='d-flex justify-content-start align-items-center'>
                      <img
                          src={require("../../assets/images/client-default.png")}
                          alt=''
                          style={{ width: '65px', height: '65px' }}
                          className='rounded-circle bg-light'
                      />
                      <div className='ms-3'>
                        <h6 className='mb-1'>{clientData.Billing_name}</h6>
                        <small className='d-block text-secondary'>Added on : <span className='text-black'>{new Date(clientData.createdAt).toLocaleDateString('en-GB')}</span></small>
                        <small className='d-block text-secondary'>Client ID : <span className='ms-1 text-black'>CLT-{clientData.Client_id}</span></small>

                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body className='pb-0'>
                    {clientData.ClientDetails.length > 0 && (
                      <ul className='clit_det'>
                        <li><small><i className='pi pi-building'></i> Company :</small>  <span>{clientData.ClientDetails[0]?.comp_name || 'N/A'}</span></li>
                        <li><small><i className='pi pi-user'></i>POC :</small>  <span>{clientData.ClientDetails[0]?.poc || 'N/A'}</span></li>
                        <li><small><i className='pi pi-phone'></i>Phone No. :</small>  <span>{clientData.ClientDetails[0]?.phone || 'N/A'}</span></li>
                        <li><small><i className='pi pi-envelope'></i>Email :</small>  <span>{clientData.ClientDetails[0]?.email || 'N/A'}</span></li>
                        <li><small><i className='pi pi-receipt'></i>Bill Name :</small>  <span>{clientData.ClientDetails[0]?.bill_name || 'N/A'}</span></li>
                        <li><small><i className='pi pi-ticket'></i>GST No. :</small>  <span>{clientData.ClientDetails[0]?.gstin || 'N/A'}</span></li>
                        <li><small><i className='pi pi-ticket'></i>Pan No. :</small>  <span>{clientData.ClientDetails[0]?.pan || 'N/A'}</span></li>
                        <li><small><i className='pi pi-map-marker'></i>Address :</small>  <span>{clientData.ClientDetails[0]?.bill_address || 'N/A'}</span></li>
                        <li className='d-flex justify-content-end align-items-center'>
                          <Button
                            label={isExpanded ? 'Less...' : 'More...'}
                            severity='primary'
                            text
                            className='border-0 p-0'
                            onClick={toggleView}
                          />
                        </li>
                      </ul>
                    )}
                    {isExpanded && (
                      <div>
                        {clientData.ClientDetails.length > 1 ? (
                          <ul className="clit_det py-3">
                            {clientData.ClientDetails.slice(1).map((detail, index) => {
                              // Define the fields dynamically
                              const fields = [
                                { label: "Company", icon: "pi pi-building", key: "comp_name" },
                                { label: "POC", icon: "pi pi-user", key: "poc" },
                                { label: "Phone No.", icon: "pi pi-phone", key: "phone" },
                                { label: "Email", icon: "pi pi-envelope", key: "email" },
                                { label: "Bill Name", icon: "pi pi-receipt", key: "bill_name" },
                                { label: "GST No.", icon: "pi pi-ticket", key: "gstin" },
                                { label: "Pan No.", icon: "pi pi-ticket", key: "pan" },
                                { label: "Address", icon: "pi pi-map-marker", key: "bill_address" },
                              ];

                              return (
                                <React.Fragment key={index}>
                                  {fields.map((field, fieldIndex) => (
                                    <li key={fieldIndex}>
                                      <small>
                                        <i className={field.icon}></i> {field.label}:
                                      </small>
                                      <span> {detail[field.key] || "N/A"}</span>
                                    </li>
                                  ))}
                                  <hr />
                                </React.Fragment>
                              );
                            })}
                          </ul>
                        ) : (
                          <ul className="clit_det py-3">
                            <li>
                              <small>
                                <i className="pi pi-info-circle"></i> Additional Info:
                              </small>
                              <span> No additional client details available.</span>
                            </li>
                          </ul>
                        )}
                      </div>
                    )}
                  </Card.Body>
                  <Card.Footer className='d-flex justify-content-end align-items-center bg-light'>
                    <Link to={`/Graphe/dashboard/edit_client/${clientId}`}>
                      <Button
                        icon='pi pi-user-edit'
                        label='Edit'
                        severity='info'
                        className='border-0 py-2'
                      />
                    </Link>

                  </Card.Footer>
                </Card>
                {/* <Card className='mt-4 h-auto'>
                  <Card.Body>
                    <Chart type="bar" data={chartData} options={chartOptions} />
                  </Card.Body>
                </Card> */}
              </Col>
              <Col xl={8}>
                <Card className="shadow-0">
                  <Card.Body className='pt-0 px-0'>
                    <TabView>

                      <TabPanel header="Projects" leftIcon="pi pi-folder-open me-2">
                        <Client_projects clientId={clientId}/>
                      </TabPanel>
                      {/* <TabPanel header="Documents" leftIcon="pi pi-file-pdf me-2">
                        <p className="m-0">
                          No documents attached
                        </p>
                      </TabPanel> */}
                      <TabPanel header="Onboarding Details" leftIcon="pi pi-box me-2">
                        <Client_onboarding_details clientId={clientId}/>
                      </TabPanel>
                      <TabPanel header="Invoices" leftIcon="pi pi-receipt me-2">
                        <Client_for_invoice clientId={clientId} />
                      </TabPanel>
                    </TabView>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Row>
    </>
  );
};

export default View_client;